import React, { useState } from "react";

import { PrimaryButton } from "@shared/buttons";
import Spinner from "@shared/spinner";
import { usePrefs } from "@utils/client-side-preferences";

import BaseErrorPage from "./base-error-page";

export default function DevelopmentAnalyticsDataErrorScreen() {
  const prefs = usePrefs();

  const [loading, setLoading] = useState(false);

  return (
    <BaseErrorPage
      pageName="ErrorScreen"
      pageBody={
        <>
          <h4 className="mt-4 text-center">
            <b>
              It looks like you enabled development data but it's not available
              for this client.
            </b>
          </h4>
          <div className="flex items-center justify-center">
            <PrimaryButton
              disabled={loading}
              tabIndex={40}
              className="mt-4 mb-2 flex items-center gap-2"
              onClick={async () => {
                setLoading(true);
                await prefs.setUseDevelopmentAnalyticsData(false);
                window.location.reload();
              }}
            >
              {loading && <Spinner colorClassname="text-white-400" />}
              TURN OFF DEVELOPMENT DATA AND RELOAD
            </PrimaryButton>
          </div>
        </>
      }
    />
  );
}
